module.exports = __webpack_public_path__ + "8043e161f25d5dd19718bbe904ba6ac8.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2048_teaser_image.jpg
// module id = 577
// module chunks = 0